import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { generateAIResponse } from "@/services/aiService";
import type { Agent } from "@/types/agent";

interface ChatMessage {
  sender: "user" | "ai";
  text: string;
  timestamp: string;
}

export const useChatMessages = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [chatInput, setChatInput] = useState("");
  const { toast } = useToast();

  const handleSendMessage = async (selectedAgent: Agent | null) => {
    if (!chatInput.trim() || !selectedAgent?.apiKey) {
      toast({
        title: "Erro",
        description: selectedAgent?.apiKey
          ? "Digite uma mensagem"
          : "Configure a chave API do agente primeiro",
        variant: "destructive",
      });
      return;
    }

    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    const userMessage = {
      sender: "user" as const,
      text: chatInput,
      timestamp: currentTime,
    };

    setMessages((prev) => [...prev, userMessage]);
    setChatInput("");

    try {
      const aiResponse = await generateAIResponse(chatInput, selectedAgent);

      const aiMessage = {
        sender: "ai" as const,
        text: aiResponse || "Desculpe, não consegui processar sua mensagem.",
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      toast({
        title: "Erro",
        description: "Erro ao processar a mensagem",
        variant: "destructive",
      });
    }
  };

  return {
    messages,
    setMessages,
    chatInput,
    setChatInput,
    handleSendMessage,
  };
};